import { callService } from "../../services/services";
import { setDocuments } from "./actions";
import { updateAlert } from "../alert/actions";
import { stateHandler } from "../../utils/enums";
import { addProcessContext } from "../processContext/actions";

export const getDocuments = (body) => {
  return async (dispatch) => {
    return await callService("generateDocument", body, dispatch,body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          dispatch(
            setDocuments({
              documents: data.docList,
              appReferenceNoOrder: data.appReferenceNoOrder,
            })
          );
        } else {
          throw data;
        }
      })
      .catch((err) => {

        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if(err.errorText){
          errText = err.errorText;
        } 

        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};

export const saveDocuments = (body) => {
  return async (dispatch) => {
    return await callService("saveDocuments", body, dispatch,body.externalId)
      .then((response) => {
        
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
      });
  };
};

export const used = (body) => {
  return async (dispatch) => {
    return await callService("used", body, dispatch,body.externalId)
      .then((response) => {
        const data = response.data;
        
        return data;
        
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return {nextStatus: false, result: "1", msg:err};
      });
  };
};
